declare const jQuery: any;
const $ = jQuery;

const config = {
	ajaxUrl: '/wp-admin/admin-ajax.php',
	action: 'iw_mail_signup'
};

export function init(): void
{
	$(`[data-iw-mc-form]`).each(function () {
		initForm($(this));
	})
}

function initForm($form): void
{
	const $email = $form.find('[data-mc-main-email]');
	if ($email.length < 1)
	{
		return;
	}

	const $btn = $form.find('[name="mc-submit"]');
	const $textInputs = $form.find('[data-mc-main-email],[data-mc-text-input]');
	const $checkboxes = $form.find('[data-mc-checkbox]');
	const $successMsg = $form.find('.mail-signup-form-success');
	const $errorMsg = $form.find('.mail-signup-form-error');
	const $inputDiv = $form.find('.mail-signup-form-inputs');
	const $optIn = $form.find(`[data-opt-in-checkbox]`);

	function disable()
	{
		$btn.attr('disabled', 'disabled');
		$form.addClass("busy");
	}

	function enable()
	{
		$btn.removeAttr('disabled');
		$form.removeClass("busy");
	}

	function onSuccess()
	{
		$successMsg.css("display", "block");
		$errorMsg.css("display", "none");
		$inputDiv.css("display", "none");
		$form.trigger("success");
	}

	function onError(errorData: any): void
	{
		$errorMsg.html(errorData.user_msg).css("display", "block");
		$form.trigger("error");
	}

	function onComplete(): void
	{
		enable();
		$form.trigger("complete");
	}

	function optedIn(): boolean
	{
		if ($optIn.length === 0)
		{
			return true;
		}
		return $optIn.prop("checked");
	}

	function readFields()
	{
		let fields: any = {};
		$textInputs.each(function eachInput() {
			const $input = $(this);
			const value: string = $.trim($input.val() || "");
			if (!value && $input.is("[required]"))
			{
				fields = null;
				alert($input.attr("data-label") + " is a required field!");
				return false;
			}
			const name = $.trim($input.attr("name"));
			if (name.toUpperCase() === "NAME" && value)
			{
				const valueSubs: string[] = value.split(/\s+/g);
				fields.FNAME = valueSubs[0] || "";
				if (valueSubs.length > 1)
				{
					fields.LNAME = valueSubs[valueSubs.length - 1] || "";
				}
			}
			else
			{
				fields[name] = value;
			}
		});
		if (!fields)
		{
			return null;
		}
		$checkboxes.filter(":checked").each(function () {
			const $input = $(this);
			const value = $input.val();
			const name = $input.attr("name");
			if (!fields[name])
			{
				fields[name] = value;
				return;
			}
			fields[name] += "|" + value;
		});
		return fields;
	}

	function submit(): void
	{
		if (!optedIn())
		{
			alert("You must opt in by ticking the checkbox.");
			return;
		}
		$errorMsg.css("display", "none");
		$successMsg.css("display", "none");
		const fields = readFields();
		if (!fields)
		{
			return;
		}
		const data = {
			action: config.action,
			data: JSON.stringify({ fields })
		};
		disable();
		$form.trigger("submit");
		$.ajax({
			type: 'POST',
			dataType: 'json',
			url: config.ajaxUrl,
			data: data,
			success: function success(response) {
				response = response || {};
				if (!response.ok)
				{
					onError({ dev_msg: response.dev_msg || "Missing OK response from server" });
					return;
				}
				if (response.dev_msg)
				{
					console.log(response.dev_msg);
				}
				onSuccess();
			},
			error: function error(jqXHR, textStatus, errorThrown) {
				const errorData = jqXHR.responseJSON || {};
				if (!errorData.user_msg)
				{
					errorData.user_msg = 'An unknown error occurred - if the problem persists, please get in touch.';
				}
				onError(errorData);
				console.error(errorData.dev_msg || "Mail signup error. See PHP log.");
				console.error(errorData, jqXHR.status, textStatus);
			},
			complete: onComplete
		});
	}

	enable();

	$btn.on('click', function onClick(e) {
		e.preventDefault();
		submit();
		return false;
	});
}
